export default __webpack_public_path__ + "static/media/italic-icon.1c43b60e.svg";